<template>
  <div id="app">
    <app-navigation>
      <!-- Load the App Navigation Component-->
    </app-navigation>
    <keep-alive>
      <transition
        :name="transitionName"
        mode="out-in"
      >
        <router-view>
          <!-- Load the router-view component provided by the vue-router plugin -->
        </router-view>
      </transition>
    </keep-alive>
  </div>
</template>

<script>
const DEFAULT_TRANSITION = 'fade';
import AppNavigation from './components/AppNavigation';
export default {
	components: {
		'app-navigation': AppNavigation,
  },
  data() {
    return {
      prevHeight: 0,
      transitionName: DEFAULT_TRANSITION,
      wpData: wpData,
    };
  },
  mounted() {
     let menuScript = document.createElement('script')
    menuScript.setAttribute('src', this.wpData.template_directory_uri + '/spa/assets/js/demo.js');
    document.head.appendChild(menuScript);
    let tweenmaxScript = document.createElement('script')
    tweenmaxScript.setAttribute('src', this.wpData.template_directory_uri + '/spa/assets/js/Tweenmax.min.js');
    document.head.appendChild(tweenmaxScript);
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
  },
};
</script>

<style>
#app {
  font-family: brandinglight;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.slide-up-enter-active,
.slide-up-leave-active{
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  /* transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1); */
  overflow: hidden;
}

.slide-up-enter{
  opacity: 0;
  transform: translate(0, 2em);
}

.slide-up-leave-active {
  opacity: 0;
  transform: translate(0, 2em);
}
</style>


// WEBPACK FOOTER //
// src/App.vue